var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reviews-seo-block"},[_c('div',{staticClass:"reviews-seo-block--text",domProps:{"innerHTML":_vm._s(_vm.info.description)}}),_c('main-button',{staticClass:"reviews-seo-block--actions",attrs:{"label":_vm.$t('viewCatalog'),"outline":""},on:{"change-event":_vm.goToCatalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }